<template>
  <v-toolbar class="search-panel" dark color="primary">
    <v-flex xs9 class="search-box pr-0 ml-0">
      <v-flex class="search-input-container white">
        <input
          type="text"
          v-model="getSearch.keyword"
          v-bind:placeholder="$t('Search')"
          v-on:keyup.enter="search()"
          class="search-input pa-0 pl-1 ml-0"
        />
        <!-- <v-text-field
          v-model="keyword"
          v-bind:placeholder="$t('Search')"
          v-on:keyup.enter="search()"
          height="35"
          clearable
          v-bind:clear-icon-cb="reset()"
          solo
          light
          class="search-input pa-0 pl-1"
        ></v-text-field> -->
        <button class="clear-button" v-on:click="reset()">
          <v-icon medium>cancel</v-icon>
        </button>
      </v-flex>
    </v-flex>
    <v-flex xs3 class="panel-buttons-container mr-0 pl-1">
      <v-btn class="ma-0" icon v-on:click="search()">
        <v-icon class="search-icon pa-1" color="secondary">search</v-icon>
      </v-btn>
      <v-btn class="ma-0" icon>
        <rp-cart-button></rp-cart-button>
      </v-btn>
    </v-flex>
  </v-toolbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SearchPanel',
  data () {
    return {
      keyword: ''
    }
  },
  computed: {
    ...mapGetters([
      'getSearch'
    ])
  },
  methods: {
    ...mapActions([
      'searchProducts',
      'setSearchStatus',
      'setKeywordSearch'
    ]),
    reset () {
      this.setKeywordSearch('')
      this.setSearchStatus(false)
    },
    search () {
      this.setKeywordSearch(this.getSearch.keyword).then(result => {
        this.searchProducts(this.getSearch.keyword).then(results => {
          this.setSearchStatus(true)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-panel {
  box-shadow: none;
  height: 56px;

  .search-box {
    /* width: 80%; */
    padding: 10px 10px;

    .search-input-container {
      position: relative;
      height: 35px;
      border-radius: 5px;
      /* width: 80%; */
      .search-input {
        height: 35px;
        width: 100%;
        color: #000000;
      }
      .clear-button {
        position: absolute;
        right: 7px;
        top: 3px;

        .icon {
          color: #cccccc;
        }
      }
    }
  }

  .panel-buttons-container {
    .search-icon {
      height: 35px;
      width: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productsList/SearchPanel.vue